import template from './item_history.html';
import controller from './item_history.controller';
import './item_history.scss';

let itemHistoryComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default itemHistoryComponent;


// WEBPACK FOOTER //
// ./client/app/components/item/print/item_history.component.js